// @flow
import { compose } from "redux";
import { connect } from "react-redux";

import modularui from "../_modularui/ModularUIConnector";
import { push } from "../_router/RouterActions";

import type { PushAction } from "../_router/types";
import type { LocationShape } from "react-router";
import type { AbstractComponent } from "react";
import Href from "../../models/href/Href";

type OwnProps = { href: Href };
type DispatchProps = {
  push: (location: LocationShape | string, state?: { ... }) => PushAction,
};

type Props = {
  ...OwnProps,
  ...DispatchProps,
};

const mapDispatchToProps: DispatchProps = {
  push,
};

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useQuicksearch' instead
 */
export const connectQuickSearch: (
  Component: AbstractComponent<Props>,
) => AbstractComponent<OwnProps> = compose(
  connect<Props, OwnProps, _, _, _, _>(null, mapDispatchToProps),
  modularui("QuickSearch", ({ href }) => href, {
    propName: "search",
  }),
);
